// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"8eef4970","365":"98218af0","411":"d60943bf","453":"258b012d","477":"50967e75","913":"877c1925","934":"68a31e08"}[chunkId] + ".chunk.js";
};